import React from 'react';
import './NotEntitledOverlay.css';
import { CenterFrameLayout } from 'Layouts';

const NotEntitledOverlay = ({ selectedMVPD: { selectedMVPD } }) => {
  const providerName = selectedMVPD.name;
  const providerHelpLink = selectedMVPD.helpLink;
  const titleString = `Your ${providerName} subscription does not include Fox Nation`;
  return (
    <CenterFrameLayout customClass="mvpdNotIncludedTitle" noPanel title={titleString}>
      <div className="notEntitledPanel">
        <div className="notEntitledPanelWrapper">
          <div className="secondaryText">
            {`To add Fox Nation to your ${providerName} subscription, please visit `}
            <a href={`https://${providerHelpLink}`}>{providerHelpLink}</a>
          </div>
          <a href="https://nation.foxnews.com/" className="pillButton">
            Back to Fox Nation
          </a>
        </div>
      </div>
    </CenterFrameLayout>
  );
};

export default NotEntitledOverlay;
